module.exports = __webpack_public_path__ + "img/logo-icon.d1556a49.svg";